<div class="token-invalid-page">
    <div class="content">
        <p>
            <b
                >The dealer code you entered is either invalid or does not correspond with the link you used to access EZ DOCS. Please close this window and try
                again.</b
            >
        </p>
        <p>If you have any questions or need help, please reach out to us.</p>

        <div class="support-wrap">
            <p><b>EZ DOCS Support</b></p>

            <p>Phone: {{ tenantSupportPhone }}</p>
            <p>Email: {{ tenantSupportEmail }}</p>
        </div>
    </div>
</div>
